module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/badges_png/reward_badge_iron_ghost-af9619aac5405cbd24755cc434366a7f.png";